import { ArrowUp, ArrowDown } from 'lucide-react';
import { TableHead, TableHeader, TableRow } from '../ui/Table';
import { Checkbox } from '../ui/Checkbox';
import { TableHeadLabel, TableOrder } from './types';
import { cn } from '../../lib/utils';

// ----------------------------------------------------------------------

interface TableHeadCustomProps {
  order?: TableOrder;
  orderBy?: string;
  headLabel: TableHeadLabel[];
  rowCount?: number;
  numSelected?: number;
  onSort?: (id: string) => void;
  onSelectAllRows?: (checked: boolean) => void;
}

export default function TableHeadCustom({
  order,
  orderBy,
  headLabel,
  rowCount = 0,
  numSelected = 0,
  onSort,
  onSelectAllRows
}: TableHeadCustomProps) {
  return (
    <TableHeader>
      <TableRow>
        {onSelectAllRows && (
          <TableHead className="w-10 px-2">
            <Checkbox
              checked={rowCount > 0 && numSelected === rowCount}
              onCheckedChange={(checked) => onSelectAllRows(checked as boolean)}
              aria-label="Select all"
              className="translate-y-[2px]"
            />
          </TableHead>
        )}

        {headLabel.map((headCell) => (
          <TableHead
            key={headCell.id}
            className={cn(
              'min-w-0 overflow-hidden',
              (headCell.align === 'left' || headCell.align === undefined) && 'text-left',
              headCell.align === 'center' && 'text-center',
              headCell.align === 'right' && 'text-right',
              onSort && headCell.id && 'cursor-pointer select-none'
            )}
            style={{
              width: headCell.width,
              minWidth: headCell.minWidth
            }}
            onClick={() => onSort && headCell.id && onSort(headCell.id)}
          >
            <div
              className={cn(
                'flex min-w-0 items-center gap-1',
                (headCell.align === 'left' || headCell.align === undefined) && 'justify-start',
                headCell.align === 'center' && 'justify-center',
                headCell.align === 'right' && 'justify-end'
              )}
            >
              <span className="min-w-0 truncate">
                {headCell.label}
              </span>
              {onSort && headCell.id && orderBy === headCell.id && (
                <span className="shrink-0 text-muted-foreground">
                  {order === 'desc' ? (
                    <ArrowDown className="h-3 w-3" />
                  ) : (
                    <ArrowUp className="h-3 w-3" />
                  )}
                </span>
              )}
            </div>
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  );
}
